<template>
  <div
    class="w-full px-4 py-2 italic text-sm text-left border border-gray-500 bg-gray-200 grid grid-cols-auto-1-auto gap-4 text-gray-800 rounded"
    @click="toggleable ? toggleInfo() : false"
  >
    <div>
      <icon name="Info" />
    </div>
    <div v-if="infoVisible">
      <slot></slot>
    </div>
    <div class="tracking-wider uppercase font-medium not-italic" v-else>{{ title || 'Info' }}</div>
    <div v-if="toggleable">
      <icon :name="infoVisible ? 'Close' : 'Plus'" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",
  data() {
    return {
      infoVisible: false
    };
  },
  props: {
    toggleable: {
      default: false,
      type: Boolean
    },
    title: {
      default: null,
      type: String
    }
  },
  components: {},
  methods: {
    toggleInfo() {
      this.infoVisible = !this.infoVisible;
    }
  },
  computed: {},
  created() {
    this.infoVisible = !this.toggleable;
  }
};
</script>